import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../models';

/** Representa o Filter da entidade Cidade */
export class CidadeFilter implements Filter {
    nome: string;
    idEstado: number;
    classificacao: number;
    idMesorregiao: number;
    idMicrorregiao: number;
    idRegiaoGeograficaImediata: number;
    idRegiaoGeograficaIntermediaria: number;

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Nome
        if (this.nome && this.nome.trim().length > 0) {
            params = params.append('nome', this.nome);
        }
        // Estado
        if (this.idEstado) {
            params = params.append('idEstado', this.idEstado.toString());
        }
        // Classificação
        if (this.classificacao) {
            params = params.append('classificacao', this.classificacao.toString());
        }
        // Mesorregião
        if (this.idMesorregiao) {
            params = params.append('idMesorregiao', this.idMesorregiao.toString());
        }
        // Microrregião
        if (this.idMicrorregiao) {
            params = params.append('idMicrorregiao', this.idMicrorregiao.toString());
        }
        // Região Geográfica Imediata
        if (this.idRegiaoGeograficaImediata) {
            params = params.append('idRegiaoGeograficaImediata', this.idRegiaoGeograficaImediata.toString());
        }
        // Região Geográfica Intermediária
        if (this.idRegiaoGeograficaIntermediaria) {
            params = params.append('idRegiaoGeograficaIntermediaria', this.idRegiaoGeograficaIntermediaria.toString());
        }

        return params;
    }

    clear() {
        this.nome = null;
        this.idEstado = null;
        this.classificacao = null;
        this.idMesorregiao = null;
        this.idMicrorregiao = null;
        this.idRegiaoGeograficaImediata = null;
        this.idRegiaoGeograficaIntermediaria = null;
    }
}

